import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zOtpCode, zPhoneNumber } from './phoneFields'

const zPhoneLoginForm = z.object({
  phoneNumber: zPhoneNumber,
  code: zOtpCode,
})

export type PhoneLoginForm = z.infer<typeof zPhoneLoginForm>

export const usePhoneLoginForm = () => {
  const form = useForm<PhoneLoginForm>({
    defaultValues: {
      phoneNumber: '',
      code: '',
    },
    resolver: zodResolver(zPhoneLoginForm),
  })

  return form
}
